var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19H20C20.5523 19 21 19.4477 21 20V20C21 20.5523 20.5523 21 20 21H9V19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0688 4.17553C16.5067 2.61338 13.974 2.61336 12.4119 4.17548L4.17353 12.4138C2.57599 14.0114 2.61761 16.6141 4.26542 18.1597L6.42916 20.1893C6.98526 20.7109 7.71911 21.0012 8.48157 21.0012H9.17194C9.96758 21.0012 10.7306 20.6852 11.2932 20.1226L19.8261 11.5899C21.3882 10.0278 21.3883 7.49514 19.8262 5.93302L18.0688 4.17553ZM13.8261 5.58969C14.6072 4.80863 15.8735 4.80865 16.6546 5.58972L18.412 7.34721C19.193 8.12827 19.193 9.39459 18.4119 10.1756L15.0003 13.5872L10.4145 9.00134L13.8261 5.58969ZM9.00024 10.4156L5.58774 13.8281C4.78897 14.6268 4.80978 15.9282 5.63369 16.701L7.79743 18.7306C7.9828 18.9045 8.22741 19.0012 8.48157 19.0012H9.17194C9.43716 19.0012 9.69151 18.8959 9.87904 18.7083L13.5861 15.0014L9.00024 10.4156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.f1c53e1798da1613fd29f23c7d08a065.svg";
export { ForwardRef as ReactComponent };